module.exports = __webpack_public_path__ + "fonts/OpenSans-LightItalic.57c3b3a3.ttf";